// Purpose-built API calls (as opposed to the generic /api/d1 table CRUD in d1-storage.ts)

import type { AdminCoupleActivity, AdminPeople } from '@/types';

export async function fetchAdminPeople(): Promise<AdminPeople> {
  const res = await fetch('/api/admin/people');
  if (!res.ok) {
    const text = await res.text().catch(() => 'unknown');
    throw new Error(`fetchAdminPeople failed: ${res.status} - ${text}`);
  }
  return res.json();
}

export async function fetchCoupleActivity(coupleId: string): Promise<AdminCoupleActivity> {
  const res = await fetch(`/api/admin/couple-activity?coupleId=${encodeURIComponent(coupleId)}`);
  if (!res.ok) {
    const text = await res.text().catch(() => 'unknown');
    throw new Error(`fetchCoupleActivity failed: ${res.status} - ${text}`);
  }
  return res.json();
}

/**
 * Record a session start for the admin People overview.
 * Deduped per browser tab session, so reloads don't count as new logins.
 */
export function recordLoginEvent(userType: 'couple' | 'reviewer', userId: string, userName?: string): void {
  const key = `vb-login-recorded:${userType}:${userId}`;
  try {
    if (sessionStorage.getItem(key)) return;
  } catch {
    // sessionStorage unavailable (private mode) — record anyway
  }
  fetch('/api/login-event', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userType, userId, userName }),
    keepalive: true,
  })
    .then(res => {
      if (res.ok) {
        try { sessionStorage.setItem(key, '1'); } catch { /* ignore */ }
      }
    })
    .catch(() => {});
}
